// removed by extract-text-webpack-plugin
module.exports = {"spinner":"profession-loading__spinner___2OY3T","rotation":"profession-loading__rotation___1_5qD","container":"profession-loading__container___1tSj9","suggestionContainer":"profession-loading__suggestionContainer____R6dp","suggestion":"profession-loading__suggestion___205v7","suggestionFocused":"profession-loading__suggestionFocused___3tYhx","sectionSuggestionsContainer":"profession-loading__sectionSuggestionsContainer___vhHJ8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/profession/profession-loading.scss
 ** module id = 1303
 ** module chunks = 1
 **/